import $ from 'jquery';

export default {

	init() {

		const carouselGallery = $('.js-carousel-gallery');

		if (carouselGallery.length > 0) {
			carouselGallery.slick();
		}

	}

};
